<!-- src/app/cascade-of-care/dashboard-costmetrics.html -->
<div class="rounded-xl shadow-sm costWidget">
    <h2 class="text-lg font-semibold text-slate-800 mb-4">Cost Metrics (Span of 15 Years)</h2>

    <!-- Info banner -->
    <div class="mb-3 rounded-lg border border-sky-200 bg-sky-50 text-sky-800 px-4 py-2 text-sm">
        Cost details are based on the Latest Simulation Run:
        <strong>{{ selectedSimulation$ | async }}</strong>. @if (showNoSimInfo) {
        <span> Please add simulations to view Healthcare Cost Savings and Net Benefits. </span>
        }
    </div>

    <div class="grid grid-cols-1 xs:grid-cols-2 sm:grid-cols-2 lg:grid-cols-3 gap-3">
        <!-- C4C Intervention Cost -->
        <div class="rounded-xl border border-slate-200 px-4 py-3">
            <div class="flex items-center justify-between">
                <div class="flex items-center gap-2">
                    <div class="costImage">
                        <img src="../../../../../assets/images/cost-metric/c4c.svg" alt="" />
                    </div>
                    <div class="costContent">
                        <div class="costContentTop">
                            <span class="text-sm font-medium text-slate-700">C4C Intervention Cost</span>
                            <button pButton type="button" class="p-button-text" (click)="popover1.toggle($event)">&#8505;</button>
                        </div>
                        <div class="costContentBottom">
                            <div class="mt-2">
                                <span class="text-slate-900 font-semibold">{{ c4cInterventionCostDisplay }}</span>
                            </div>
                        </div>
                        <p-popover #popover1>
                            <div class="text-slate-700 text-sm">Total cost of implementing Cardio4Cities interventions over 15 years.</div>
                        </p-popover>
                    </div>
                </div>
            </div>
        </div>

        <!-- Healthcare cost savings -->
        <div class="rounded-xl border border-slate-200 px-4 py-3">
            <div class="flex items-center justify-between">
                <div class="flex items-center gap-2">
                    <div class="costImage">
                        <img src="../../../../../assets/images/cost-metric/saving.svg" alt="" />
                    </div>
                    <div class="costContent">
                        <div class="costContentTop">
                            <span class="text-sm font-medium text-slate-700">Healthcare cost savings</span>
                            <button pButton type="button" class="p-button-text" (click)="popover2.toggle($event)">&#8505;</button>
                        </div>
                        <div class="costContentBottom">
                            <div class="mt-2">
                                <span class="text-slate-900 font-semibold">{{ healthcareSavingsDisplay }}</span>
                            </div>
                        </div>
                        <p-popover #popover2>
                            <div class="text-slate-700 text-sm">Projected savings from avoided hospitalisation, complications and treatment</div>
                        </p-popover>
                    </div>
                </div>
            </div>
        </div>

        <!-- Net Cost -->
        <div class="rounded-xl border border-slate-200 px-4 py-3">
            <div class="flex items-center justify-between">
                <div class="flex items-center gap-2">
                    <div class="costImage">
                        <img src="../../../../../assets/images/cost-metric/net.svg" alt="" />
                    </div>
                    <div class="costContent">
                        <div class="costContentTop">
                            <span class="text-sm font-medium text-slate-700">Net Cost</span>
                            <button pButton type="button" class="p-button-text" (click)="popover3.toggle($event)">&#8505;</button>
                        </div>
                        <div class="costContentBottom">
                            <div class="mt-2">
                                <span class="text-slate-900 font-semibold">{{ netCostDisplay }}</span>
                            </div>
                        </div>
                        <p-popover #popover3>
                            <div class="text-slate-700 text-sm">Intervention cost minus healthcare cost savings</div>
                        </p-popover>
                    </div>
                </div>
            </div>
        </div>

        <!-- QALY -->
        <div class="rounded-xl border border-slate-200 px-4 py-3">
            <div class="flex items-center justify-between">
                <div class="flex items-center gap-2">
                    <div class="costImage">
                        <img src="../../../../../assets/images/cost-metric/qaly.svg" alt="" />
                    </div>
                    <div class="costContent">
                        <div class="costContentTop">
                            <span class="text-sm font-medium text-slate-700">QALY</span>
                            <button pButton type="button" class="p-button-text" (click)="popover4.toggle($event)">&#8505;</button>
                        </div>
                        <div class="costContentBottom">
                            <div class="mt-2">
                                <span class="text-slate-900 font-semibold">{{ qalyDisplay }}</span>
                            </div>
                        </div>
                        <p-popover #popover4>
                            <div class="text-slate-700 text-sm">QALY (Quality Adjusted Life Years) - Additional healthy life years gained through interventions.</div>
                        </p-popover>
                    </div>
                </div>
            </div>
        </div>

        <!-- Net Benefit -->
        <div class="rounded-xl border border-slate-200 px-4 py-3">
            <div class="flex items-center justify-between">
                <div class="flex items-center gap-2">
                    <div class="costImage">
                        <img src="../../../../../assets/images/cost-metric/benefit.svg" alt="" />
                    </div>
                    <div class="costContent">
                        <div class="costContentTop">
                            <span class="text-sm font-medium text-slate-700">Net Benefit</span>
                            <button pButton type="button" class="p-button-text" (click)="popover5.toggle($event)">&#8505;</button>
                        </div>
                        <div class="costContentBottom">
                            <div class="mt-2">
                                <span class="text-slate-900 font-semibold">{{ netBenefitDisplay }}</span>
                            </div>
                        </div>
                        <p-popover #popover5>
                            <div class="text-slate-700 text-sm">Overall economic and health benefit after costs and savings are considered.</div>
                        </p-popover>
                    </div>
                </div>
            </div>
        </div>

        <!-- Total Budget -->
        <div class="rounded-xl border border-slate-200 px-4 py-3">
            <div class="flex items-center justify-between">
                <div class="flex items-center gap-2">
                    <div class="costImage">
                        <img src="../../../../../assets/images/cost-metric/budget.svg" alt="" />
                    </div>
                    <div class="costContent">
                        <div class="costContentTop">
                            <span class="text-sm font-medium text-slate-700">Total Budget</span>
                            <button pButton type="button" class="p-button-text" (click)="popover6.toggle($event)">&#8505;</button>
                        </div>
                        <div class="costContentBottom">
                            <div class="mt-2">
                                <span class="text-slate-900 font-semibold">$0</span>
                            </div>
                        </div>
                        <p-popover #popover6>
                            <div class="text-slate-700 text-sm">City's allocated healthcare budget for cardiovascular health for over 15 years</div>
                        </p-popover>
                    </div>
                </div>
            </div>
        </div>
    </div>
</div>
